/**
 * App
 * ------
 * Specify vendor and app specific js files to be compiled
*/

// Bootstrap requires
require('./vendor/bootstrap-requires.js');

// Optional Vendor Requires
// require('./vendor/imagesloaded.pkgd.min.js');
// require('./vendor/jquery.actual.min');
// require('./vendor/jquery.validate.min');
// require('./vendor/object-visual-lock');
// require('./vendor/js.cookie');
require('./vendor/magnify-image');
require('./vendor/slick');

import { Fancybox } from "@fancyapps/ui";
window.Fancybox = Fancybox;

// require('./vendor/animation.gsap.min');
// require('./vendor/animation.velocity.min');

//require('./vendor/connections');
// require('./vendor/youtube-iframe-assistant');
// require('./vendor/picturefill');
// require('./vendor/waypoint');
// require('./vendor/waypoint-animate');

// App Requires
require('./app/dropcap');
require('./app/image-fullscreen');
require('./app/image-offsets');
require('./app/match-width');
require('./app/popovers');
require('./app/contact-menu');
require('./app/primary-nav');
require('./app/back-button');
// require('./app/scribble-lines');
require('./app/sticky-buttons');
require('./app/toggles');
require('./app/modals/modal-zoom');
require('./app/modals/modal-manifesto');
require('./app/modals/modal-video');
require('./app/animations/global-animations');
require('./app/posts-more');
require('./app/scale-container');
require('./app/gravity-forms');
require('./app/smooth-scroll');

// Sliders
require('./app/sliders/slider-fade');
require('./app/sliders/slider-services');
//require('./app/sliders/slider-stacked-5');
require('./app/sliders/slider-testimonials');
require('./app/sliders/slider-zoom');
require('./app/sliders/slider-logos');

// Interactions
require('./app/interactions/leader-circles');
require('./app/interactions/interactions-about');
require('./app/interactions/interactions-careers');
require('./app/interactions/interactions-homepage');
require('./app/interactions/interactions-industries');
require('./app/interactions/interactions-services');
require('./app/interactions/interactions-insights');


